import { createSamplesSlice, createSamplesSliceTransformer } from '@op/services'

export const samplesSlice = createSamplesSlice((s) => {
	s.src && URL.revokeObjectURL(s.src)
})

export const samplesSliceTransformer = createSamplesSliceTransformer(samplesSlice)
